const IconService = {
    cyboLogoBlue: require('@/assets/cybo_logo_blue.svg'),
    cyboLogoDark1: require('@/assets/logo/cybo_logo_dark_1.svg'),
    cyboLogoCybo: require('@/assets/logo/cybo_logo_cybo.svg'),

    iconTrash: require('@/assets/icon_trash.svg'),
    iconImage: require('@/assets/icon_image.svg'),
    iconPdf: require('@/assets/icon_pdf.svg'),
    iconDocument: require('@/assets/icon_document.svg')
}

export { IconService }
